import BlameApp from './blame/BlameApp';

function StatsTecnicaTab({
    castellersInfo,
    setCastellersInfo,
    ...props
}) {
    return (
        <BlameApp
            castellersInfo={castellersInfo}
            setCastellersInfo={setCastellersInfo}
            hideHeader={true}
            {...props}
        />
    );
}

export default StatsTecnicaTab;
